<template>
    <ayuda-tema-base
        :busqueda="busqueda"
        :color="color"
        :faqs="faqs"
        video-url="https://share.synthesia.io/embeds/videos/0ad913fe-23e9-48ca-aa80-1dd18a17f69c"
        video-titulo="Nueva solicitud"
    />
</template>

<script>
import AyudaTemaBase from './AyudaTemaBase.vue';

export default {
    name: 'AyudaTemaSolicitudes',
    components: {
        AyudaTemaBase
    },
    props: {
        busqueda: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: '#2E7D32'
        }
    },
    data() {
        return {
            faqs: [
                {
                    id: 1,
                    pregunta: '¿Qué campos son obligatorios para crear una solicitud?',
                    respuesta: `
                        <p>Debes completar camino, idioma, fecha, habitaciones, peregrinos y el campo <strong>Código de la reserva en la Agencia</strong>.</p>
                    `,
                    respuestaTexto: 'Debes completar camino, idioma, fecha, habitaciones, peregrinos y el campo Código de la reserva en la Agencia.'
                },
                {
                    id: 2,
                    pregunta: '¿Cuándo se recalculan las tarifas?',
                    respuesta: `
                        <p>Las tarifas se recalculan automáticamente cuando cambias:</p>
                        <ul>
                            <li>Camino</li>
                            <li>Fechas</li>
                            <li>Cantidades de habitaciones</li>
                        </ul>
                    `,
                    respuestaTexto: 'Las tarifas se recalculan automáticamente cuando cambias camino, fechas o cantidades de habitaciones.'
                },
                {
                    id: 3,
                    pregunta: '¿Por qué no me deja avanzar al siguiente paso?',
                    respuesta: `
                        <p>Normalmente ocurre por una de estas razones:</p>
                        <ul>
                            <li>Falta un campo obligatorio</li>
                            <li>No hay una distribución válida entre habitaciones y peregrinos</li>
                        </ul>
                    `,
                    respuestaTexto: 'Normalmente ocurre porque falta un campo obligatorio o no hay una distribución válida entre habitaciones y peregrinos.'
                },
                {
                    id: 4,
                    pregunta: '¿Cómo se reparte correctamente el número de habitaciones?',
                    respuesta: `
                        <p>La suma de habitaciones debe ser coherente con el número de peregrinos.</p>
                        <p>Si la distribución no cuadra, el sistema no permitirá continuar al siguiente paso.</p>
                    `,
                    respuestaTexto: 'La suma de habitaciones debe ser coherente con el número de peregrinos. Si la distribución no cuadra, el sistema no permitirá continuar al siguiente paso.'
                },
                {
                    id: 5,
                    pregunta: '¿Puedo editar una solicitud antes de enviarla?',
                    respuesta: `
                        <p>Sí. Mientras no confirmes el último paso puedes:</p>
                        <ul>
                            <li>Volver atrás</li>
                            <li>Cambiar fechas</li>
                            <li>Modificar habitaciones</li>
                            <li>Actualizar datos del cliente</li>
                        </ul>
                    `,
                    respuestaTexto: 'Sí. Mientras no confirmes el último paso puedes volver atrás, cambiar fechas, modificar habitaciones y actualizar datos del cliente.'
                },
                {
                    id: 6,
                    pregunta: '¿Qué ocurre si no aparece disponibilidad o precio?',
                    respuesta: `
                        <p>Suele deberse a una combinación no válida de fechas, ocupación o servicios.</p>
                        <p>Revisa el camino, el idioma y la distribución de habitaciones antes de volver a intentarlo.</p>
                    `,
                    respuestaTexto: 'Suele deberse a una combinación no válida de fechas, ocupación o servicios. Revisa el camino, el idioma y la distribución de habitaciones antes de volver a intentarlo.'
                }
            ]
        };
    }
};
</script>
